define('OutSystems/ClientRuntime/CSSHelper',["require", "exports", "./Logger", "./Settings"], function (require, exports, Logger, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getIgnoreLoadErrors = exports.setIgnoreLoadErrors = exports.scheduleCSSPreparation = exports.getNumberOfStylesheetLoadRetries = exports.setNumberOfStylesheetLoadRetries = exports.hasClass = exports.conditionClass = exports.removeClass = exports.addClass = void 0;
    var CSS_HELPER_MODULE_NAME = "CSSHelper";
    function addClass(element, className) {
        if (className) {
            if (element.classList) {
                element.classList.add(className);
            }
            else if (!hasClass(element, className)) {
                element.className = element.className + " " + className;
            }
        }
        return element;
    }
    exports.addClass = addClass;
    function removeClass(element, className) {
        if (className) {
            if (element.classList) {
                element.classList.remove(className);
            }
            else if (hasClass(element, className)) {
                element.className = element.className
                    .replace(new RegExp("(^|\\s)" + className + "(?:\\s|$)", "g"), "$1")
                    .replace(/\s+/g, " ")
                    .replace(/^\s*|\s*$/g, "");
            }
        }
        return element;
    }
    exports.removeClass = removeClass;
    function conditionClass(element, className, condition) {
        return (condition ? addClass : removeClass)(element, className);
    }
    exports.conditionClass = conditionClass;
    function hasClass(element, className) {
        if (element.classList) {
            return !!className && element.classList.contains(className);
        }
        return (" " + element.className + " ").indexOf(" " + className + " ") > -1;
    }
    exports.hasClass = hasClass;
    var lastDiffTimestamp = 0;
    var numberOfStylesheetLoadRetries = 3;
    function setNumberOfStylesheetLoadRetries(value) {
        Logger.trace(CSS_HELPER_MODULE_NAME, "Setting number of stylesheet's load retries to " + value);
        numberOfStylesheetLoadRetries = value;
    }
    exports.setNumberOfStylesheetLoadRetries = setNumberOfStylesheetLoadRetries;
    function getNumberOfStylesheetLoadRetries() {
        return numberOfStylesheetLoadRetries;
    }
    exports.getNumberOfStylesheetLoadRetries = getNumberOfStylesheetLoadRetries;
    function scheduleCSSPreparation(urls, onError, onRetry) {
        if (urls.length === 0) {
            return {
                loadStylesPromise: Promise.resolve(),
                triggerRemoveStyles: function () { },
            };
        }
        var head = document.head || document.querySelector("head");
        var existingStyles = [].slice.call(document.querySelectorAll("link[data-os]") || []).reverse();
        var stylesBeingLoaded = [];
        var stylesToRetain = [];
        var stylesToAdd = [];
        var lastAddedStyle = undefined;
        var resumeOffIndex = 0;
        iterateUrls: for (var _i = 0, _a = urls.reverse(); _i < _a.length; _i++) {
            var url = _a[_i];
            for (var i = resumeOffIndex; i < existingStyles.length; i++) {
                var style_1 = existingStyles[i];
                if (style_1.id === url) {
                    lastAddedStyle = style_1;
                    stylesToRetain.push(style_1);
                    resumeOffIndex = i + 1;
                    continue iterateUrls;
                }
            }
            var style = loadStylesheet(url, stylesBeingLoaded, onError, numberOfStylesheetLoadRetries, onRetry);
            stylesToAdd.push({ beforeElement: lastAddedStyle, element: style });
            lastAddedStyle = style;
        }
        traceLength("Adding", stylesToAdd);
        for (var _b = 0, stylesToAdd_1 = stylesToAdd; _b < stylesToAdd_1.length; _b++) {
            var _c = stylesToAdd_1[_b], beforeElement = _c.beforeElement, element = _c.element;
            traceStylesheet("Adding", element.id);
            if (beforeElement) {
                head.insertBefore(element, beforeElement);
            }
            else {
                head.appendChild(element);
            }
        }
        lastDiffTimestamp += 1;
        var removalTimestamp = lastDiffTimestamp;
        var removeStyles = function () {
            if (lastDiffTimestamp !== removalTimestamp) {
                return;
            }
            traceLength("Retaining", stylesToRetain);
            for (var _i = 0, stylesToRetain_1 = stylesToRetain; _i < stylesToRetain_1.length; _i++) {
                var styleToRetain = stylesToRetain_1[_i];
                traceStylesheet("Retaining", styleToRetain.id);
            }
            for (var _a = 0, existingStyles_1 = existingStyles; _a < existingStyles_1.length; _a++) {
                var stylesheet = existingStyles_1[_a];
                if (stylesheet.parentNode && stylesToRetain.indexOf(stylesheet) === -1) {
                    traceStylesheet("Removing", stylesheet.id);
                    stylesheet.parentNode.removeChild(stylesheet);
                }
            }
        };
        return {
            loadStylesPromise: Promise.all(stylesBeingLoaded),
            triggerRemoveStyles: removeStyles,
        };
    }
    exports.scheduleCSSPreparation = scheduleCSSPreparation;
    function traceLength(action, styles) {
        Logger.trace(CSS_HELPER_MODULE_NAME, action + " " + styles.length + " stylesheets : document '" + document.baseURI + "':");
    }
    function traceStylesheet(action, stylesheet) {
        Logger.trace(CSS_HELPER_MODULE_NAME, action + " stylesheet '" + stylesheet + "' : document '" + document.baseURI + "'");
    }
    var ignoreLoadErrors = false;
    function setIgnoreLoadErrors(value) {
        Logger.trace(CSS_HELPER_MODULE_NAME, "Setting ignore load errors to " + value);
        ignoreLoadErrors = value;
    }
    exports.setIgnoreLoadErrors = setIgnoreLoadErrors;
    function getIgnoreLoadErrors() {
        return ignoreLoadErrors;
    }
    exports.getIgnoreLoadErrors = getIgnoreLoadErrors;
    function traceStylesheetError(cssURL, logger, extendedMessage) {
        if (extendedMessage === void 0) { extendedMessage = ""; }
        if (!ignoreLoadErrors) {
            logger("Error loading stylesheet: '" + cssURL + "'" + extendedMessage);
        }
        else {
            Logger.trace(CSS_HELPER_MODULE_NAME, "Ignored error while loading stylesheet '" + cssURL + "'" + extendedMessage);
        }
    }
    function createStylesheetElement(cssURL) {
        var style = document.createElement("link");
        style.type = "text/css";
        style.rel = "stylesheet";
        style.id = cssURL;
        style.href = cssURL;
        style.setAttribute("data-os", "true");
        return style;
    }
    function retryOnErrorStylesheet(resolve, ev, style, cssURL, onError, retriesLeft, onRetry) {
        if (retriesLeft === 0) {
            traceStylesheetError(cssURL, onError, "\nNo retries left.\nFailed to load this stylesheet.");
            style.parentNode.removeChild(style);
            resolve(ev);
            return;
        }
        onRetry === null || onRetry === void 0 ? void 0 : onRetry();
        Logger.trace(CSS_HELPER_MODULE_NAME, "Error while loading stylesheet '" + cssURL + "'. Retrying...");
        var newStyle = createStylesheetElement(cssURL);
        newStyle.onerror = function () {
            retryOnErrorStylesheet(resolve, ev, newStyle, cssURL, onError, retriesLeft - 1, onRetry);
        };
        newStyle.onabort = style.onabort;
        newStyle.onload = style.onload;
        var styleParentNode = style.parentNode;
        var styleNextSibling = style.nextElementSibling;
        style.parentNode.removeChild(style);
        if (styleNextSibling) {
            styleParentNode.insertBefore(newStyle, styleNextSibling);
        }
        else {
            styleParentNode.appendChild(newStyle);
        }
    }
    function loadStylesheet(cssURL, styleheetsBeingLoaded, onError, retries, onRetry) {
        Logger.trace(CSS_HELPER_MODULE_NAME, "Loading stylesheet '" + cssURL + "'");
        var style = createStylesheetElement(cssURL);
        styleheetsBeingLoaded.push(new Promise(function (resolve) {
            style.onerror = function (ev) {
                var numRetries = Settings_1.getEnvParams().CDNFilenameVersioning ? retries : 0;
                retryOnErrorStylesheet(resolve, ev, style, cssURL, onError, numRetries, onRetry);
            };
            style.onabort = function (ev) {
                traceStylesheetError(cssURL, onError);
                style.parentNode.removeChild(style);
                resolve(ev);
            };
            style.onload = resolve;
        }));
        return style;
    }
});
//# sourceMappingURL=CSSHelper.js.map;
